import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InfoChipSize } from '../info-chip/info-chip.types';
import { MunilyAreaCardData, MunilyAreaCardIconSet, MunilyAreaCardType } from './area-card.types';

@Component({
  selector: 'common-area-card',
  templateUrl: './area-card.component.html',
  styleUrls: ['./area-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaCardComponent {
  @Input() data!: MunilyAreaCardData;

  @Output() select = new EventEmitter<void>();
  @Output() menuClick = new EventEmitter<void>();

  get type(): MunilyAreaCardType {
    return this.data?.type ?? 'picture';
  }

  get showRating(): boolean {
    return this.data?.showRating ?? true;
  }

  get capacityLabel(): string {
    return this.data?.capacityLabel ?? 'Capacidad:';
  }

  get menuIcon(): string {
    return this.data?.menuIcon ?? 'more_vert';
  }

  get menuIconSet(): MunilyAreaCardIconSet {
    return this.data?.menuIconSet ?? 'material-symbols-rounded';
  }

  get showMenuButton(): boolean {
    return this.data?.showMenuButton ?? true;
  }

  /** Compat: `default` (chip antiguo) → `large`; sin valor → `small` (footer area card). */
  chipSizeResolved(size?: InfoChipSize | 'default'): InfoChipSize {
    if (size === 'small') {
      return 'small';
    }
    if (size === 'large' || size === 'default') {
      return 'large';
    }
    return 'small';
  }

  onSelect(): void {
    this.select.emit();
  }

  onMenuClick(): void {
    this.menuClick.emit();
  }
}

